"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/getInnerHeight.js
// module id = 785
// module chunks = 95715928098905 168707334958949